import * as marietta from '../../..';
import { Dialog } from '../../../core/view';

/**
 * 住宅設備自動生成確認ダイアログ
 * ボタン押下で表示
 */
class ConfirmGenerateEquipmentDialog extends Dialog {
  /**
     * コンストラクタ
     */
  constructor(draggable: boolean) {
    super(draggable);

    // ダイアログのコンテンツ生成
    const id = 'confirmGenerateEquipmentDialog';
    const title = '';

    const { currentFloor } = marietta.webcad.WebCADGlobal.webcad2Dmanager;
    let contents = '<div class="confirmGenerateEquipment">\n';
    contents += `<span class="jp">${currentFloor}階の住宅設備を全て削除し、住宅設備の自動生成を行いますか？</span><span class="en">Would you like to delete all the equipment on ${currentFloor}F and run the auto equipment generation?</span>`;

    contents += '</div>\n';

    let footer = '<button value="true"><span class="jp">はい</span><span class="en">Yes</span></button>';
    footer += '<button><span class="jp">いいえ</span><span class="en">No</span></button>';

    this.createDialog(id, title, contents, footer);

    this.viewObj.querySelectorAll('button').forEach((element) => {
      element.addEventListener('click', this.btnEventHandler);
    });
  }

    /**
     * ボタンがクリックされた
     */
    btnEventHandler = (e) => {
      e.preventDefault();
      if ((e.currentTarget).value) {
        marietta.webcad.WebCADGlobal.cadAPIManager.generateEquipment();
      }
      this.close();
    }
}

export default ConfirmGenerateEquipmentDialog;
